<template>
  <van-empty
    class="custom-image"
    image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
    :description="text || '暂无数据'"
  />
</template>

<script>
import { Empty } from 'vant';

export default {
  name: 'ForumEmptyState',
  components: {
    [Empty.name]: Empty,
  },
  props: {
    text: String,
  },
};
</script>

<style scoped>
.custom-image {
  padding: 96px 24px;
}
</style>
